import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Icon, } from './atoms';
import { Text } from 'atoms';
import { CloseSvg, DefaultLabelIconSvg } from 'components/icons';

const template = styled.div`
  ${({ displayState }) => css`
    display: inline-flex;
    align-items: center;
    padding: 4px 6px;
    font-size: 12px;
    line-height: 14px;
    background-color: ${displayState.active ? `${window?.settings?.primary_color ?? '#1DBD6B'}0D` : '#FFF4F4'};
    color: ${displayState.active ? window?.settings?.primary_color ?? '#1DBD6B' : '#FD2020'};
    margin-top: 8px;
    border-radius: 4px;
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: 'InactiveIcon',
      displayValue: ({ }) => CloseSvg({ width: "18", height: "18", color: "#FD2020" }),
      displayState: ({ active }) => ({ hidden: active })
    },
    {
      component: Icon,
      name: 'ActiveIcon',
      displayValue: ({ }) => DefaultLabelIconSvg({ color: window?.settings?.primary_color ?? '#1DBD6B' }),
      displayState: ({ active }) => ({ hidden: !active })
    },
    {
      component: Text,
      name: 'Text',
      displayValue: ({ text }) => text,
    },
  ],
})